import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TNotificationsSettings,
  TSeasonalSettings,
  TUpdateSeasonalSettings,
} from './settings.types.ts';

export const settingsApi = {
  getSeasonalSettings: async () => {
    const response = await axios.get<TSeasonalSettings>('settings/seasonal');

    return response.data;
  },
  updateSeasonalSettings: async (seasonalSettings: TUpdateSeasonalSettings) => {
    const response = await axios.patch<TSeasonalSettings>('settings/seasonal', seasonalSettings);

    return response.data;
  },
  notificationSettings: async () => {
    const response = await axios.get<TNotificationsSettings>('notifications/settings');

    return response.data;
  },
  updateNotificationSettings: async (data: Record<string, boolean>) => {
    const response = await axios.patch<TNotificationsSettings>('notifications/settings', data);

    return response.data;
  },
};

export const settingsQueries = createQueryKeys('seasonal-settings', {
  getSeasonalSettings: () => ({
    queryKey: ['settings'],
    queryFn: () => settingsApi.getSeasonalSettings(),
  }),
  notificationSettings: () => ({
    queryKey: ['notificationSettings'],
    queryFn: () => settingsApi.notificationSettings(),
  }),
});
